module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_type_chapel@2x-8a394521e983d35c4615b45ad339b070.webp";